import type { AllRouteEndpoints } from "../routeTypes";
export const companiesWorkspaceRateLimitsUpsertCacheKeys: AllRouteEndpoints[] = [];
